var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartmentbtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 11.5625C4.6875 11.1978 4.83237 10.8481 5.09023 10.5902C5.34809 10.3324 5.69783 10.1875 6.0625 10.1875H11.5625C11.9272 10.1875 12.2769 10.3324 12.5348 10.5902C12.7926 10.8481 12.9375 11.1978 12.9375 11.5625",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 7.4375V10.1875",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 12.9375C5.875 12.2817 5.34334 11.75 4.6875 11.75C4.03166 11.75 3.5 12.2817 3.5 12.9375V14.3125C3.5 14.9683 4.03166 15.5 4.6875 15.5C5.34334 15.5 5.875 14.9683 5.875 14.3125V12.9375Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 12.9375C14.125 12.2817 13.5933 11.75 12.9375 11.75C12.2817 11.75 11.75 12.2817 11.75 12.9375V14.3125C11.75 14.9683 12.2817 15.5 12.9375 15.5C13.5933 15.5 14.125 14.9683 14.125 14.3125V12.9375Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.6875C10 4.03166 9.46834 3.5 8.8125 3.5C8.15666 3.5 7.625 4.03166 7.625 4.6875V6.0625C7.625 6.71834 8.15666 7.25 8.8125 7.25C9.46834 7.25 10 6.71834 10 6.0625V4.6875Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentbtn);
export default __webpack_public_path__ + "static/media/departmentbtn.1a4388928b059513206cedc9541f15f2.svg";
export { ForwardRef as ReactComponent };